import type { ComponentProps } from 'react';
import { useMemo } from 'react';
// components
import HubiversePropertySelect from 'components/Selects/HubiversePropertySelect';
import type { TFormFieldUpdater } from '../FormFieldUpdater';
import FormFieldUpdater from '../FormFieldUpdater';
// Create question context
import { ECreateQuestionMode, useQuestionEditorContext } from '../../../context/create-question.context';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';

import { selectQuestionMode } from 'rtk/questionEditorSelector';
import { updateFormHubiverseProperty } from 'rtk/Question.Editor.Slice';
import type { EFormType } from '@hubertai/screening-question-types';
import { type TFormSubType } from '@hubertai/screening-question-types';
import { useTranslation } from 'react-i18next';

interface Props extends ComponentProps<'div'> {
  form: TFormSubType & { type: EFormType.Phone };
  formIndex: number;
}

const CreateFormPhone = ({ form, formIndex, ...props }: Props) => {
  console.log('CreateFormPhone', form, formIndex);
  const { t } = useTranslation('Questionsv2');
  const dispatch = useAppDispatch();
  const { questionId } = useQuestionEditorContext();
  const mode = useAppSelector((state) => selectQuestionMode(state, questionId));
  const formFieldValues: TFormFieldUpdater[] = useMemo(
    () => [
      {
        label: t('form.phone.placeholder.label'),
        description: t('form.phone.placeholder.description'),
        formKey: 'placeholder',
        fieldType: 'text',
        formValuesKey: 'placeholder',
        form,
        formIndex,
      },
    ],
    [t, form, formIndex],
  );

  return (
    <div {...props}>
      {formFieldValues.map((x, index) => {
        return (
          <FormFieldUpdater
            key={`form-field-updater-${form.id}-${index}`}
            label={x.label}
            description={x.description}
            formKey={x.formKey}
            fieldType={x.fieldType}
            formValuesKey={x.formValuesKey}
            form={x.form}
            formIndex={x.formIndex}
          />
        );
      })}
      <HubiversePropertySelect
        selected={form.candidate_property ?? ''}
        onSelect={(e: string) => {
          dispatch(updateFormHubiverseProperty({ questionId, formIndex, value: e }));
        }}
        includeLabel={true}
        // @ts-ignore
        isDisabled={mode === ECreateQuestionMode.InTemplateEdit}
      />
    </div>
  );
};

export default CreateFormPhone;
